<template>
  <DownloadsSection />
</template>

<script>
import DownloadsSection from '../../components/downloads/DownloadsSection.vue'

export default {
  name: 'DownloadsPage',
  components: { DownloadsSection },
  inject: ['front'],
  mounted() {
    if (!this.front.publicFiles.length) {
      this.front.selectPublicFileCategory(this.front.activePublicFileCategory)
    }
  }
}
</script>
